import { OVERALL_CATEGORY, resolveBudget } from "../../lib/budgets";
import { roundMoney } from "../../lib/money-math";
import type { DashboardData, OwnerFilter } from "../../types";
import { insightPeriod, monthDays } from "./insight-period";

export function insightBudget(data: Pick<DashboardData, "baseCurrency" | "budgets">, owner: OwnerFilter, month: string, today: string, spending: number | null) {
  const budget = resolveBudget(data.budgets, owner === "All" ? "Household" : owner, OVERALL_CATEGORY, month);
  const limit = budget?.amount != null && budget.currency === data.baseCurrency ? budget.amount : null;
  const period = insightPeriod(month, today);
  const projected = spending === null || !period.current || period.elapsedDays < 7 ? null :
    roundMoney(spending / period.elapsedDays * monthDays(month));
  return {
    limit, budget, projected,
    remaining: limit === null || spending === null ? null : roundMoney(limit - spending),
    projectedRemaining: limit === null || projected === null ? null : roundMoney(limit - projected),
    current: period.current,
  };
}
